import { Component } from '@angular/core';
import { IzzyPersonSkillEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Person Skills') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzypersonskill-form',
    templateUrl: './izzypersonskill.form.component.html'
})
export class IzzyPersonSkillFormComponent extends BaseFormComponent {
    public record!: IzzyPersonSkillEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'skillAssignment', sectionName: 'Skill Assignment', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

